module.exports = __webpack_public_path__ + "img/new2.a8b3a515.jpeg";